var React = require('react');

function TrustFbInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M70 35.7616C70 16.4328 54.3288 0.761597 35 0.761597C15.6713 0.761597 0 16.4328 0 35.7616C0 53.2324 12.7983 67.7108 29.5312 70.3358V45.8795H20.6442V35.7587H29.5312V28.0528C29.5312 19.2824 34.7579 14.4349 42.7525 14.4349C46.5792 14.4349 50.5867 15.1203 50.5867 15.1203V23.7333H46.1708C41.8221 23.7333 40.4658 26.4312 40.4658 29.1991V35.7616H50.1725L48.6208 45.8824H40.4658V70.3387C57.2017 67.7108 70 53.2295 70 35.7616Z","fill":"#1877F2"}));
}

TrustFbInline.defaultProps = {"width":"70","height":"71","viewBox":"0 0 70 71","fill":"none","aria-hidden":"true"};

module.exports = TrustFbInline;

TrustFbInline.default = TrustFbInline;
